module.exports = __webpack_public_path__ + "static/NCSC-Certified-5de384c8fef5c77498e4f2592e9ba525.png";